import { useNavigate } from 'react-router-dom';
import useSubscription from '../hooks/useSubscription';
import { fmtDate } from '../utils/api';
import { IcAlert } from './Icons';

// Inline reminder banner for unsubscribed / expired undergrad students.
// Renders nothing when the subscription is active or still loading.
// Shown on pages that stay open to free users (e.g. the dashboard).
export default function SubscriptionReminder({ style }) {
  const navigate = useNavigate();
  const { status, daysLeft, endDate } = useSubscription();

  if (status === 'loading' || status === 'active') return null;

  const palette = status === 'grace'
    ? { bg: 'var(--warn-l)', border: 'rgba(214,137,16,0.35)', fg: 'var(--warn)' }
    : { bg: 'var(--err-l)',  border: 'rgba(192,57,43,0.25)',  fg: 'var(--err)' };

  const heading = status === 'grace'
    ? `Grace period — ${daysLeft} day${daysLeft !== 1 ? 's' : ''} left`
    : status === 'expired'
      ? 'Your subscription has expired'
      : "You're not subscribed yet";

  const body = status === 'grace'
    ? `Your subscription expired on ${fmtDate(endDate)}. Renew to keep full access to courses, assignments, quizzes, past questions and your ID card.`
    : status === 'expired'
      ? `Your subscription expired on ${fmtDate(endDate)}. As a free user you can use the dashboard, news feed, flashcards (limited), messages and study groups. Subscribe to unlock everything.`
      : 'As a free user you can use the dashboard, news feed, flashcards (limited), messages and study groups. Subscribe to unlock courses, assignments, quizzes, past questions, certificates and your ID card.';

  return (
    <div style={{
      background: palette.bg, border: `1px solid ${palette.border}`, borderRadius: 'var(--radius-md)',
      padding: '14px 18px', marginBottom: 20, display: 'flex', justifyContent: 'space-between',
      alignItems: 'center', flexWrap: 'wrap', gap: 12, ...style,
    }}>
      <div style={{ minWidth: 0 }}>
        <div style={{ fontWeight: 700, color: palette.fg, marginBottom: 3 }}>
          <IcAlert size={14} style={{ verticalAlign: 'middle', marginRight: 6 }} />{heading}
        </div>
        <div style={{ fontSize: 12.5, color: 'var(--txt-m)', lineHeight: 1.55 }}>{body}</div>
      </div>
      <button className="btn btn-primary btn-sm" style={{ flexShrink: 0 }} onClick={() => navigate('/subscription')}>
        {status === 'grace' || status === 'expired' ? 'Renew now' : 'Subscribe'}
      </button>
    </div>
  );
}
